import { Maybe, MediaImage, ImageFile, ImageFormat } from '@/@types/graphql'

function imageFormat (formats: any[], key: string = 'xs'): any | undefined  {
  const image = formats.find((item) => item.name === key)
  if (!image) return
  return image.file
}

function smallerImageUrl (image: Maybe<MediaImage> | undefined) {
  if (!image) return null
  const files = [image.file]
  if (image.formats) files.push(...image.formats.map((format) => format.file))
  const compareSize = (a: ImageFile, b: ImageFile) => a.size - b.size
  files.sort(compareSize)
  return files[0]?.url || null
}

function smallerImageFormatUrl (formats: Maybe<ImageFormat[]>) {
  if (!formats) return
  const files = formats.map((format) => format.file)
  const compareSize = (a: ImageFile, b: ImageFile) => a.size - b.size
  files.sort(compareSize)
  return files[0]?.url || null
}

export {
  imageFormat,
  smallerImageUrl,
  smallerImageFormatUrl
}

export default {
  imageFormat,
  smallerImageUrl,
  smallerImageFormatUrl
}
